import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/pages/startpage/src/assets/templates-preview-1x.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')